import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postTreatment } from "../../services/post.service";
import { treatment, treatmentRange } from "../../validations/Validation";

export interface IUseCreateTreatment {
  onSubmit: (data: any) => void;
  registerGeneral: any;
  registerRange: any;
  unRegisterRange: any;
  handleSubmitGeneral: any;
  handleSubmitRange: any;
  errorsGeneral: any;
  errorsRange: any;
  formValue: any;
  setFormValue: any;
  rangeFields: any;
  appendRange: any;
  rangeRemove: any;
  loading: boolean;
}

export const useCreateTreatment = (): IUseCreateTreatment => {
  const [formValue, setFormValue] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const naviagte = useNavigate();

  const onSubmit = () => {
    setLoading(true);
    var id = toast.loading("Please wait...", {
      theme: "colored",
      type: "info",
      closeButton: true,
    });

    postTreatment(formValue)
      .then((res) => {
        toast.update(id, {
          render: res.data,
          type: "success",
          theme: "colored",
          autoClose: 2500,
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        setLoading(false);
        naviagte("/treatments");
      })
      .catch((err) => {
        toast.update(id, {
          render: err?.response?.data?.detail,
          theme: "colored",
          autoClose: 5000,
          type: "error",
          isLoading: false,
          closeOnClick: true,
          hideProgressBar: false,
        });
        setLoading(false);
        console.log(err);
      });
  };

  const {
    register: registerGeneral,
    handleSubmit: handleSubmitGeneral,
    control,
    formState: { errors: errorsGeneral },
  } = useForm({
    resolver: yupResolver(treatment),
    defaultValues: { ranges: formValue.ranges },
  });

  const {
    register: registerRange,
    handleSubmit: handleSubmitRange,
    unregister: unRegisterRange,
    formState: { errors: errorsRange },
  } = useForm({
    resolver: yupResolver(treatmentRange),
  });

  const {
    fields: rangeFields,
    append: rangeAppend,
    remove: rangeRemove,
  } = useFieldArray({
    control,
    name: "ranges",
  });

  const appendRange = () => {
    rangeAppend({});
  };

  return {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerRange,
    handleSubmitRange,
    unRegisterRange,
    errorsRange,
    appendRange,
    rangeFields,
    rangeRemove,
    loading,
  };
};
